import { createAction, props } from "@ngrx/store";
export const setGenericDocPointsListing_State = createAction(
  "[Column 1 View Model] Set Generic Doc Points Listing State",
  props<{ genericDocPointsListingState: any }>()
);